import Div from "@jumbo/shared/Div";
import {
  Typography,
  Box,
  Tab,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grid,
  Tooltip,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  DateFormatter,
  formatIndianNumber,
} from "app/shared/ReuseComponents/DateFormatter";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import axios from "axios";
import { BASE_URL } from "app/services/auth-services";
import { FoyerCloseButton } from "app/shared/ReuseComponents/ButtonComponent";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { MdClose } from "react-icons/md";
import SingleAttachment from "./SingleAttachment";
import { useGetPurchaseRequestWorkflowAPIQuery } from "app/services/RTK_Apis/PayrollManagement/CreatePayroll/HrApprovalApi";
import { useGetEmployeeClaimByIdQuery } from "app/services/RTK_Apis/EmployeeClaims/EmployeeClaimsApi";

const ViewEmployeeClaims = ({
  setListOverview,
  setlistreimbursement,
  currentData,
}) => {
  const token = localStorage.getItem("accesstoken");
  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);
  let companyId = userDetails && userDetails.Organization_Id;
  let id1 = userDetails && userDetails.id;
  let partnerId = parseInt(localStorage.getItem("PartnerId"));

  const [openDoc, setOpenDoc] = useState(false);
  const [docUrl, setDocUrl] = useState("");

  const [value, setValue] = useState("1");
  

  const {
  data: workflowData,
  isLoading: workflowLoading,
  isError: workflowError,
} = useGetPurchaseRequestWorkflowAPIQuery(
  { requestId: currentData?.Employeeclaim_Id },
  { skip: !currentData?.Employeeclaim_Id }
);

const {
  data: claimDetails,
  isLoading: claimLoading,
  isError: claimError,
} = useGetEmployeeClaimByIdQuery(
  { Employeeclaim_Id: currentData?.Employeeclaim_Id },
  { skip: !currentData?.Employeeclaim_Id }
);

const newData = claimDetails;
const approvalStatus = workflowData?.[0]?.Approve || [];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClose = () => {
    setListOverview(false);
    setlistreimbursement(true);
  };

  const getFileName = (path) => {
    if (!path) return "";
    return decodeURIComponent(path.split("/").pop());
  };

  const handleOpenDocument = (path) => {
    if (!path) return;
    setDocUrl(`${BASE_URL}/media/${path}`);
    setOpenDoc(true);
  };

  const handleCloseDocument = () => {
    setOpenDoc(false);
  };

  const isImageFile = (path) => {
    if (!path) return false;
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(path);
  };

  const ClaimDetailRow = ({ label, value }) => {
    const displayValue =
      value === null || value === undefined || value === "" ? "–" : value;

    return (
      <Grid
        container
        alignItems="center"
        sx={{
          py: 1.3,
          borderBottom: "1px solid #f1f5f9",
        }}
      >
        {/* LABEL */}
        <Grid item xs={12} sm={4} md={4}>
          <Typography
            sx={{
              fontSize: { xs: 13, sm: 14 },
              fontWeight: 500,
              color: "#6b7280",
            }}
          >
            {label}
          </Typography>
        </Grid>

        {/* COLON */}
        <Grid
          item
          xs={1}
          sm={1}
          md={1}
          sx={{
            display: { xs: "none", sm: "block" },
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 900,
              color: "#9ca3af",
            }}
          >
            :
          </Typography>
        </Grid>

        {/* VALUE */}
        <Grid item xs={12} sm={7} md={7}>
          <Typography
            sx={{
              fontSize: { xs: 14, sm: 14.5 },
              fontWeight: 600,
              color: "#111827",
              wordBreak: "break-word",
              mt: { xs: 0.4, sm: 0 },
            }}
          >
            {displayValue}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const handleDownload = () => {
    if (!docUrl) return;

    const link = document.createElement("a");
    link.href = docUrl;
    link.download = getFileName(docUrl);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenNewTab = () => {
    if (!docUrl) return;
    window.open(docUrl, "_blank", "noopener,noreferrer");
  };



  const WorkflowName = "Reimbursement";



  return (
    <div>
      <Div className="row">
        <Div className="col-sm-12 col-md-10">
          <Typography variant="h3" sx={{}}>
            Claim Overview
          </Typography>
        </Div>

        <Div>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="tabs">
                <Tab
                  label="Overview"
                  value="1"
                  sx={{ fontSize: "16px", color: "#000000" }}
                />
              </TabList>
            </Box>

            {/* ========== Overview Panel ========== */}
            <TabPanel value="1" sx={{ p: 1.5 }}>
              {/* ================= Claim Overview Section ================= */}

              <Grid container spacing={2} alignItems="flex-start">
                {/* LEFT : CLAIM DETAILS */}
                <Grid item xs={12} md={9}>
                  <Box
                    sx={{
                      background: "#ffffff",
                      borderRadius: 3,
                      p: { xs: 1, md: 2 },
                      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                    }}
                  >
                    <ClaimDetailRow
                      label="Created Date"
                      value={<DateFormatter date={currentData?.Created_Date} />}
                    />

                    <ClaimDetailRow
                      label="Claim No"
                      value={currentData?.Employeeclaim_Id}
                    />

                    <ClaimDetailRow
                      label="Claim Date"
                      value={
                        currentData?.Claim_Date ? (
                          <DateFormatter date={currentData?.Claim_Date} />
                        ) : (
                          "-"
                        )
                      }
                    />

                    <ClaimDetailRow
                      label="Reimbursement Type"
                      value={currentData?.Reimbursement_Type}
                    />

                    <ClaimDetailRow
                      label="Reimbursement Details"
                      value={currentData?.Bill_Details}
                    />

                    <ClaimDetailRow label="Month" value={currentData?.Month} />

                    <ClaimDetailRow
                      label="Eligible Amount"
                      value={formatIndianNumber(
                        currentData?.Reimbursement_Id?.Eligible_Amount,
                      )}
                    />

                    <ClaimDetailRow
                      label="Initiated Claim Amount"
                      value={formatIndianNumber(currentData?.Claim_Amount)}
                    />
                  </Box>
                </Grid>

                {/* RIGHT : STATUS IMAGE */}
                <Grid item xs={12} md={3}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "flex-start", md: "center" },
                      mt: { xs: 2, md: 0 },
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        currentData?.Approved_Flag === true &&
                        currentData?.Status === true
                          ? "./../../../../../images/StatusFlg/Approved.png"
                          : currentData?.Approved_Flag === false &&
                              currentData?.Status === true
                            ? "./../../../../../images/StatusFlg/Rejected.png"
                            : "./../../../../../images/StatusFlg/Pending.png"
                      }
                      alt="status"
                      sx={{
                        width: { xs: 120, sm: 140, md: 160 },
                        height: "auto",
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>

              {/* ================= Attachments Section ================= */}
              <Grid item xs={12} md={12} sx={{ mt: 3 }}>
                <Box
                  sx={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "6px",
                    p: 2,
                    backgroundColor: "#fafafa",
                    // maxWidth: 520,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: "16px",
                      color: "#111827",
                    }}
                  >
                    Attachments
                  </Typography>

                  {currentData?.Claim_Attachment ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 1.2,
                      }}
                    >
                      {/* <>
                        <Box
                          onClick={() =>
                            handleOpenDocument(currentData?.Claim_Attachment)
                          }
                          sx={{
                            width: 180,
                            height: 140,
                            borderRadius: 2,
                            overflow: "hidden",
                            border: "1px solid #e5e7eb",
                            cursor: "pointer",
                            background: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all .18s ease",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                            },
                          }}
                        >
                          {currentData?.Claim_Attachment ? (
                            <Box
                              component="img"
                              src={`${BASE_URL}/media/${currentData?.Claim_Attachment}`}
                              alt="attachment"
                              sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                textAlign: "center",
                                color: "#6b7280",
                              }}
                            >
                              <DescriptionIcon sx={{ fontSize: 50 }} />
                              <Typography sx={{ fontSize: 12 }}>
                                Preview
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Tooltip
                          title={getFileName(currentData?.Claim_Attachment)}
                        >
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: 500,
                              maxWidth: 180,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "#374151",
                            }}
                          >
                            {getFileName(currentData?.Claim_Attachment)}
                          </Typography>
                        </Tooltip>
                      </> */}

                      <SingleAttachment
                        file={currentData?.Claim_Attachment}
                        fileSize={currentData?.Claim_Attachment_Size} // optional
                        BASE_URL={BASE_URL}
                      />
                    </Box>
                  ) : (
                    <Typography color="text.secondary" fontSize="14px">
                      No documents attached
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Box mt={3}>
                <WorkflowApproverStatus
                  WorkflowName={WorkflowName}
                  partnerId={partnerId}
                  approvalStatus={approvalStatus}
                />
              </Box>
            </TabPanel>
          </TabContext>
        </Div>
        <Div
          className="buttons"
          sx={{ mt: 2, mb: 2, display: "flex", justifyContent: "flex-start" }}
        >
          <FoyerCloseButton onClick={handleClose} />
        </Div>
      </Div>

      {/* preview documents */}
      <Dialog
        open={openDoc}
        onClose={handleCloseDocument}
        fullScreen={window.innerWidth < 600}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          sx={{
            p: 1,
            pb: 0,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3">Claim Attachment</Typography>
          {/* ACTION BUTTONS */}
          <Box sx={{ display: "flex", gap: 1, justifyContent: "end" }}>
            {/* Open in new tab */}
            <Tooltip title="Open in new tab">
              <IconButton size="small" onClick={handleOpenNewTab}>
                <OpenInNewIcon />
              </IconButton>
            </Tooltip>

            {/* Download */}
            <Tooltip title="Download">
              <IconButton size="small" onClick={handleDownload}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            {/* Close */}
            <Tooltip title="Close">
              <IconButton size="small" onClick={handleCloseDocument}>
                <MdClose />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            height: "calc(100vh - 100px)",
            // background: "#111",
          }}
        >
          {docUrl?.match(/\.(jpeg|jpg|png|gif|webp)$/i) ? (
            <Box
              component="img"
              src={docUrl}
              alt="Claim Attachment"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "scale-down",
                // objectFit: "contain",
                // background: "#111",
              }}
            />
          ) : (
            <iframe
              src={docUrl}
              title="Document Preview"
              width="100%"
              height="100%"
              style={{ border: "none", background: "#fff" }}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ViewEmployeeClaims;
